import { CourseSchedule } from "./course-schedule";

export class NextScheduledCoursesModel {
    constructor(
        public NextScheduledSameLocation?: CourseSchedule,
        public NextScheduledDifferentLocation?: CourseSchedule,
    ) { }
}